export default __webpack_public_path__ + "static/media/Rani-Durgavati-Museum.f2216755.jpg";